var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdministrador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Administrador",
    transform: "translate(11927 16218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24810",
    "data-name": "Trazado 24810",
    d: "M12.5,25A12.5,12.5,0,1,1,25,12.5,12.514,12.514,0,0,1,12.5,25m0-23.809A11.309,11.309,0,1,0,23.808,12.5,11.321,11.321,0,0,0,12.5,1.191",
    transform: "translate(-11927 -16218)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23053",
    "data-name": "Grupo 23053",
    transform: "translate(0.283 -0.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M11.472,8.3a.978.978,0,0,1,.627-.912,3.876,3.876,0,0,0-.469-1.13.991.991,0,0,1-.4.085.976.976,0,0,1-.893-1.373A3.865,3.865,0,0,0,9.212,4.5a.977.977,0,0,1-1.825,0,3.876,3.876,0,0,0-1.13.469.976.976,0,0,1-.893,1.373.959.959,0,0,1-.4-.085A3.962,3.962,0,0,0,4.5,7.389a.978.978,0,0,1,0,1.825,3.876,3.876,0,0,0,.469,1.13.976.976,0,0,1,1.288,1.288,3.9,3.9,0,0,0,1.13.469.975.975,0,0,1,1.821,0,3.876,3.876,0,0,0,1.13-.469.977.977,0,0,1,1.288-1.288,3.9,3.9,0,0,0,.469-1.13A.983.983,0,0,1,11.472,8.3ZM8.318,9.881A1.583,1.583,0,1,1,9.9,8.3,1.583,1.583,0,0,1,8.318,9.881Z",
    transform: "translate(-11916.783 -16212.801)",
    fill: "#d5007f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user",
    "data-name": "Icon feather-user",
    transform: "translate(-11927.282 -16217.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24811",
    "data-name": "Trazado 24811",
    d: "M18.8,27.3V25.7a3.2,3.2,0,0,0-3.2-3.2H9.2A3.2,3.2,0,0,0,6,25.7v1.6",
    transform: "translate(0 -8.401)",
    fill: "none",
    stroke: "#d5007f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24812",
    "data-name": "Trazado 24812",
    d: "M18.4,7.7a3.2,3.2,0,1,1-3.2-3.2,3.2,3.2,0,0,1,3.2,3.2Z",
    transform: "translate(-2.8)",
    fill: "none",
    stroke: "#d5007f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministrador);
export default __webpack_public_path__ + "static/media/Administrador.df51a68b734200221377811ba8b9779b.svg";
export { ForwardRef as ReactComponent };